import { render, staticRenderFns } from "./Profile2.vue?vue&type=template&id=ce38cb30&scoped=true"
import script from "./Profile2.vue?vue&type=script&lang=js"
export * from "./Profile2.vue?vue&type=script&lang=js"
import style0 from "./Profile2.vue?vue&type=style&index=0&id=ce38cb30&prod&lang=scss&scoped=true"
import style1 from "./Profile2.vue?vue&type=style&index=1&id=ce38cb30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce38cb30",
  null
  
)

export default component.exports